import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as Actions from '../actions/LiveStreamManagement';

const GetListLiveStreamReducer = handleActions({
    [Actions.GetListLiveStreamEventRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetListLiveStreamEventReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.GetListLiveStreamEventReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.ClearGetListLiveStreamEvent]: () => ({
        isFetching: false,
        data: {},
        errors: {},
        success: undefined,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    success: undefined,
});

const GetDetailLiveStreamReducer = handleActions({
    [Actions.GetDetailLiveStreamEventRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetDetailLiveStreamEventReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.GetDetailLiveStreamEventReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.ClearGetDetailLiveStreamEvent]: () => ({
        isFetching: false,
        data: {},
        errors: {},
        success: undefined,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    success: undefined,
});

const UpdateLiveStreamReducer = handleActions({
    [Actions.UpdateDetailLiveStreamEventRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.UpdateDetailLiveStreamEventReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.UpdateDetailLiveStreamEventReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.ClearUpdateDetailLiveStreamEvent]: () => ({
        isFetching: false,
        data: {},
        errors: {},
        success: undefined,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    success: undefined,
});

const DeleteLiveStreamReducer = handleActions({
    [Actions.AdminDeleteLiveStreamEventRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.AdminDeleteLiveStreamEventReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.AdminDeleteLiveStreamEventReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.ClearAdminDeleteLiveStreamEvent]: () => ({
        isFetching: false,
        data: {},
        errors: {},
        success: false,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    success: false,
});

const GetListLiveStreamViewerReducer = handleActions({
    [Actions.ViewerGetListLiveStreamEventRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.ViewerGetListLiveStreamEventReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.AddDateGetListLiveStreamEventReceived]: (state, action) => ({
        ...state,
        listdate: { ...state.listdate, ...action.payload },
    }),
    [Actions.ViewerGetListLiveStreamEventReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.ClearViewerGetListLiveStreamEvent]: () => ({
        isFetching: false,
        data: {},
        errors: {},
        success: false,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    success: false,
    listdate: {},
});

const RegisterLiveStreamViewerReducer = handleActions({
    [Actions.ViewerRegisterLiveStreamRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.ViewerRegisterLiveStreamReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        registerStatus: action.payload.status,
        data: action.payload,
    }),
    [Actions.ViewerRegisterLiveStreamReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearViewerRegisterLiveStream]: () => ({
        isFetching: false,
        data: {},
        registerStatus: false,
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    registerStatus: false,
    errors: {},
});

const GetListLivestreamRegisteredViewerReducer = handleActions({
    [Actions.ViewerGetListLivestreamRegisteredRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.ViewerGetListLivestreamRegisteredReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.ViewerAddDateGetListRegisteredLivestreamRecevied]: (state, action) => ({
        ...state,
        listRegistered: { ...state.listRegistered, ...action.payload },
    }),
    [Actions.ViewerGetListLivestreamRegisteredReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.ViewerClearListLivestreamRegistered]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    listRegistered: {},
});

const GetDetailLivestreamViewerReducer = handleActions({
    [Actions.ViewerGetDetailLivestreamRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.ViewerGetDetailLivestreamReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.ViewerGetDetailLivestreamReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.ClearViewerDetailLivestream]: () => ({
        isFetching: false,
        data: {},
        errors: {},
        success: undefined,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    success: undefined,
});

const GetListLivestreamLoginAccReducer = handleActions({
    [Actions.ViewerGetListLiveStreamLoginAccRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.ViewerGetListLiveStreamLoginAccReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.AddDateGetListLiveStreamLoginAccReceived]: (state, action) => ({
        ...state,
        listdate: { ...state.listdate, ...action.payload },
    }),
    [Actions.ViewerGetListLiveStreamLoginAccReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.ClearViewerGetListLiveStreamLoginAcc]: () => ({
        isFetching: false,
        data: {},
        errors: {},
        success: false,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    success: false,
    listdate: {},
});

export default combineReducers({
    getListLiveStream: GetListLiveStreamReducer,
    getDetailLiveStream: GetDetailLiveStreamReducer,
    updateLiveStream: UpdateLiveStreamReducer,
    deleteLiveStream: DeleteLiveStreamReducer,
    getListLiveStreamViewer: GetListLiveStreamViewerReducer,
    registerLiveStreamViewer: RegisterLiveStreamViewerReducer,
    getListLivestreamRegisteredViewer: GetListLivestreamRegisteredViewerReducer,
    getDetailLivestreamViewer: GetDetailLivestreamViewerReducer,
    getListLivestreamLoginAcc: GetListLivestreamLoginAccReducer,
});
